import {
  ChangeDetectionStrategy,
  Component
} from '@angular/core';


export class SkyDefinitionListContentComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-definition-list-content',
  template: `<div class="sky-definition-list-content">
  <ng-content></ng-content>
</div>
`,
  styles: [`.sky-definition-list-content {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 5px;
}
`],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
